module.exports = __webpack_public_path__ + "img/scalable.29b8f4dc.svg";